module.exports = __webpack_public_path__ + "img/back.da35782e.jpg";